export const INCIDENCE_RESOLUTIONS_LIST_KEY = 'INCIDENCE_RESOLUTIONS_LIST';
export const INCIDENCE_RESOLUTIONS_ONE_KEY = 'INCIDENCE_RESOLUTIONS_ONE_KEY';
